import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../store/slices/employeeSlice";

export default function useWizardCommaConvert() {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const Email = localStorage.getItem("email");
  const loggedEmp = employees?.find((emp) => emp?.EmpEmail === Email);
  const countryCode = loggedEmp?.countrycode;

  const formatNumber = (num, options = {}) => {
    if (num === undefined || num === null) return "";
    const value = Number(num);
    if (isNaN(value)) return "";

    const locale = countryCode === "+91" ? "en-IN" : "en-US";

    if (options?.decimals) {
      // Preserve fractional currency (e.g. Tax); avoid float noise beyond 2 places
      const withDecimals = Math.round((value + Number.EPSILON) * 100) / 100;
      return withDecimals.toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    }

    if (countryCode === "+1") {
      return Math.round(value).toLocaleString("en-US");
    }
    if (countryCode === "+91") {
      return Math.round(value).toLocaleString("en-IN");
    }

    return Math.round(value).toLocaleString("en-US");
  };

  return formatNumber;
}
